import React from 'react'
import { FilterComponent } from '../../components/_WMS/FilterComponent/FilterComponent'
import { Filter } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './config'
interface ReorderStockSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  onAddButtonClick?: () => void
  addButtonTitle?: string
  createButtonTooltip?: string
}

export const ReorderStockSearch: React.FC<ReorderStockSearchProps> = (
  props
) => {
  return <FilterComponent options={filterOptions} {...props} />
}
